import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MailPlus, MessageCirclePlus, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";

// Lot 560 — « Ajoute un e-mail de secours » (compte WhatsApp sans e-mail) ; lot 604 — symétrique « Ajoute un numéro
// WhatsApp de secours » (compte e-mail sans numéro). CTA → Paramètres › Mon compte, fenêtre d'ajout déjà ouverte ;
// « Plus tard » → tampon serveur, retour dans 7 jours.
export const BackupEmailNudgeCard = ({ onClose }) => {
  const { t, user, refreshMe } = useApp();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const missing = (user?.email || "").trim() ? "phone" : "email";

  const later = async () => {
    setBusy(true);
    try {
      await api.post("/users/me/backup-email-nudge/later");
      refreshMe?.();
      toast(t("backup_email.later_toast", "D'accord — on te le rappellera dans 7 jours."));
    } catch { /* la carte se referme quand même pour cette session */ }
    finally { setBusy(false); onClose(); }
  };

  return (
    <div className="yalola-card p-4 relative animate-in fade-in slide-in-from-top-2 duration-500" data-testid="backup-email-nudge-card">
      <button type="button" onClick={later} disabled={busy} className="absolute top-3 right-3 p-1 rounded-full hover:opacity-70" aria-label={t("backup_email.later", "Plus tard")} data-testid="backup-email-nudge-close">
        <X size={16} style={{ color: "var(--yalola-text-muted)" }} />
      </button>
      <div className="flex items-start gap-3 pr-6">
        <div className="h-11 w-11 shrink-0 rounded-full grid place-items-center" style={{ background: "#FEF3C7", color: "#92400E" }}>{missing === "phone" ? <MessageCirclePlus size={20} /> : <MailPlus size={20} />}</div>
        <div className="min-w-0">
          <div className="font-bold font-display" data-testid="backup-email-nudge-title" data-missing={missing}>
            {missing === "phone" ? t("backup_phone.title", "Ajoute un numéro WhatsApp de secours") : t("backup_email.title", "Ajoute un e-mail de secours")}
          </div>
          <p className="text-sm mt-0.5" style={{ color: "var(--yalola-text-muted)" }} data-testid="backup-email-nudge-desc">
            {missing === "phone"
              ? t("backup_phone.desc", "Ton compte n'a qu'un seul accès : ton adresse e-mail. Si tu n'y reçois plus rien ou si tu oublies ton mot de passe, un numéro WhatsApp te permet de toujours te connecter par code.")
              : t("backup_email.desc", "Ton compte n'a qu'un seul accès : ton numéro WhatsApp. Si tu changes de numéro ou si WhatsApp est indisponible, un e-mail te permet de toujours te connecter.")}
          </p>
        </div>
      </div>
      <div className="flex items-center justify-end gap-2 mt-3">
        <Button variant="ghost" size="sm" className="rounded-full" onClick={later} disabled={busy} data-testid="backup-email-nudge-later">{t("backup_email.later", "Plus tard")}</Button>
        <Button size="sm" className="rounded-full pill-primary" onClick={() => nav(`/settings?section=compte&open=${missing}`)} data-testid="backup-email-nudge-add">
          {missing === "phone" ? t("backup_phone.add", "Ajouter un numéro") : t("backup_email.add", "Ajouter un e-mail")}
        </Button>
      </div>
    </div>
  );
};

export default BackupEmailNudgeCard;
